import { BLESSNET_ACCOUNT_FACTORY_ABI } from "@/config/abis/blessed-account-factory-abi";
import { BLESSNET_ACCOUNT_FACTORY } from "@/constants/mod-perms-tool.constants";
import type {
  ModifiedPermissionsRequest,
  SocialAccountCreationRequest,
} from "@/types/modular-permissions.types";
import type { HexString } from "@/types/general.types";
import { ethers } from "ethers";

// TODO Rename this to something more relative
export const prepareCalldata = async (
  accounts: ModifiedPermissionsRequest[],
  vault?: HexString,
) => {
  const factoryInterface = new ethers.Interface(BLESSNET_ACCOUNT_FACTORY_ABI);

  return accounts.map((account): SocialAccountCreationRequest => {
    //? Get the calldata for each social account
    const calldata = factoryInterface.encodeFunctionData("createAccount", [
      account.platform, // Platform i.e "telegram" lowercase
      account.userId, // Hashed user ID
      [], // executors_
      [] // hrs_
    ]) as HexString;

    const blessAmount = BigInt("1000000000000000"); // 0.01 BLESS

    //? Attach the calldata to each social account permission object
    return {
      vault: account.vault || vault, // TODO This may later become dynamic
      target: BLESSNET_ACCOUNT_FACTORY,
      data: calldata,
      value: blessAmount,
      ids: account.ids,
    };
  });
};
